/*
 * @Author: mikey.zhaopeng
 * @Date: 2022-01-Sa 09:58:07
 * @Last Modified by:   mikey.zhaopeng
 * @Last Modified time: 2022-01-Sa 09:58:07
 */
<template>
    <div class="listing-main">
      <!-- <div class="mask" v-if="shopifyUpgrade">
        <div class="hint">
          <div class="text f-c-c">Update the Shopify app to list new products!</div>
          <div class="btn f-c-c">Update</div>
        </div>
      </div> -->
        <el-tabs v-if="moreParams.platformCode === 'TT' && this.listForm.listingStatus == 6" v-model="listForm.productStatus" @tab-click="getList()">
          <el-tab-pane v-for="item in ttTabs" :key="item.name" :label="$t(item.label) + ` (${item.count})`" :name="item.name" />
        </el-tabs>
        <div class="f-b">
            <div class="f--c" style="height: 60px">
              <el-button v-if="moreParams.platformCode === 'PD'" round type="primary" style="margin-left:15px" @click="createProduct">{{ $t('publishListings.createProduct')}}</el-button>
              <template>
                <el-button round type="primary" style="margin-left:15px" v-if="['WaitingForUpdate'].includes(tabTitle) && tableData.length" @click="buttonHandleClickAll('Update')" :disabled="!selectionListCurrent.length">{{ $t('publishListings.Update')}}</el-button>
                <el-button round type="primary" style="margin-left:15px" v-if="['Published', 'SkuNoExist', 'WaitingForUpdate'].includes(tabTitle) && tableData.length && moreParams.platformCode !== 'PD'" @click="buttonHandleClickAll('Hidden')" :disabled="!selectionListCurrent.length || moreParams.platformCode === 'WC'">{{ moreParams.platformCode === 'TT' ? $t('publishListings.Deactivate') : $t('publishListings.Hidden')}}</el-button>
                <el-button round type="primary" style="margin-left:15px" v-if="['Hidden'].includes(tabTitle) && tableData.length" @click="buttonHandleClickAll('Relist')" :disabled="!selectionListCurrent.length">{{ moreParams.platformCode === 'TT' ? $t('publishListings.Activate') : $t('publishListings.Relist')}}</el-button>
                <el-button round type="danger" style="margin-left:15px" v-if="['Published', 'Hidden', 'ListingQueue', 'SkuNoExist', 'Suspended', 'WaitingForUpdate'].includes(tabTitle) && tableData.length && (moreParams.platformCode !== 'PD' || (moreParams.platformCode === 'PD' && !['Published'].includes(tabTitle)))" @click="buttonHandleClickAll('Delete')" :disabled="!selectionListCurrent.length">{{$t('publishListings.Delete')}}</el-button>
                <el-link type="success" style="margin: 0 15px" v-if="['Published', 'Hidden', 'ListingQueue', 'SkuNoExist', 'WaitingForUpdate'].includes(tabTitle) && tableData.length && (moreParams.platformCode !== 'PD' || (moreParams.platformCode === 'PD' && !['Published'].includes(tabTitle)))" class="actionColor">{{selectionListCurrent.length}} {{$t('publishListings.productSelected')}}</el-link>
              </template>
            </div>
            <div style="height: 60px;padding-right: 15px" class="f--c"></div>
        </div>
        <div>
          <el-table
            v-if="moreParams.platformCode === 'PD'"
            :data="tableData"
            style="width: 100%"
            :tree-props="{children: 'variants', hasChildren: 'hasChildren'}"
            row-key="id"
            :default-expand-all="false"
            @select-all="selectAll"
            @select="selectTr"
            ref="tableData">
            <el-table-column width="50" type="selection" v-if="tabTitle !== 'Deleted'">
              <template slot-scope="scope">
                <el-checkbox v-model="scope.row.isChecked" v-if="scope.row.storeId" @change="isChecked => selectTr(isChecked, scope.row)" :disabled="checkboxIsDisabled(scope.row)"></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column label="商品信息"  prop="product" class-name="product_columns" min-width="160">
              <template slot-scope="scope">
                <template v-if="scope.row.storeId">
                  <div class="f" style="height:95px">
                    <div style="margin: 0px 8px 0 0;padding-top: 10px">
                      <el-popover placement="right" width="280" trigger="hover">
                        <el-image fit="cover" :src="scope.row.materialImgUrl"></el-image>
                        <el-badge v-if="scope.row.kkProductUpdated" slot="reference" is-dot class="img-badge">
                          <el-image style="width: 64px;height: 64px;" :src="scope.row.materialImgUrl"></el-image>
                        </el-badge>
                        <el-image v-else slot="reference" style="width: 64px;height: 64px;" :src="scope.row.materialImgUrl"></el-image>
                      </el-popover>
                    </div>
                    <div class="product_title">
                      <el-tooltip effect="dark" :content="scope.row.title || scope.row.productName" placement="top">
                        <div class="ellipsis2" @click="EditProduct(scope.row)">{{ scope.row.title || scope.row.productName }}</div>
                      </el-tooltip>
                      <div>SPU Id：{{ scope.row.productId }}</div>
                    </div>
                  </div>
                </template>
                <div v-else class="f-b" style="width: 100%">
                  <div>{{scope.row.extCode || '无'}}</div>
                  <!-- <div v-if="scope.row.kkProductId && +scope.row.kkProductId === 1" style="color: red">
                    {{ $t('Publish.Listings.Components.TableList.NoExist') }}
                  </div> -->
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="supplierPrice" label="申报价格">
              <template slot-scope="scope">
                <template v-if="scope.row.supplierPrice">
                  <span style="font-weight: 600">{{scope.row.currency}} </span>
                  <span>{{scope.row.supplierPrice || '-'}}</span>
                </template>
                <template v-else>
                  <span style="font-weight: 600">{{scope.row.currency}} </span>
                  <span v-if="scope.row.price">{{scope.row.price | numberKeepTwoDecimal}}</span>
                  <span v-else>-</span>
                </template>
              </template>
            </el-table-column>
            <el-table-column label="商品属性" min-width="150">
              <template slot-scope="{row}">
                <template v-if="row.storeId">
                  <template v-if="row.productPropertyReqs.length > 2">
                    <div v-for="(t, i1) in row.productPropertyReqs" :key="t.vid">
                      <span v-if="i1 < 2">{{ t.propName }}：{{ t.propValue }} {{ t.numberInputValue ? `${+t.numberInputValue}%` : '' }}</span>
                    </div>
                    <el-popover
                      placement="bottom"
                      trigger="click">
                      <div v-for="t in row.productPropertyReqs" :key="'popover'+t.vid">
                        <span>{{ t.propName }}：{{ t.propValue }} {{ t.numberInputValue ? `${+t.numberInputValue}%` : '' }}</span>
                      </div>
                      <el-button slot="reference" type="text" style="padding:0;padding-top:4px;">查看</el-button>
                    </el-popover>
                  </template>
                  <template v-else>
                    <div v-for="t in row.productPropertyReqs" :key="t.vid">
                      <span>{{ t.propName }}：{{ t.propValue }}</span>
                    </div>
                  </template>
                </template>
                <template v-else>
                  颜色：{{ row.option1 }}
                </template>
              </template>
            </el-table-column>
            <el-table-column label="尺码表">
              <template slot-scope="{row}">
                <template v-if="row.storeId && row.sizeTemplateIds && row.sizeTemplateIds.length">
                  <el-popover
                    placement="bottom"
                    trigger="click"
                    @show="temuGetNotReusableSizeCharts(row.sizeTemplateIds)"
                    >
                    <div v-if="sizeTemplate">
                      <el-table :data="sizeTemplate.sizeList" border max-height="400" style="width: 100%">
                        <el-table-column label="尺码" prop="1" width="100" fixed></el-table-column>
                        <template v-for="item in paramColumn">
                          <el-table-column :key="item.key" min-width="120">
                            <template slot="header">
                              <div class="title" style="margin-bottom:0;">{{ item.title }}</div>
                            </template>
                            <div slot-scope="{row}">
                              <span>{{ row[item.key] }}</span>
                            </div>
                          </el-table-column>
                        </template>
                      </el-table>
                    </div>
                    <el-button slot="reference" type="text" style="padding:0;padding-top:4px;">查看</el-button>
                  </el-popover>
                </template>
                <template v-else>
                  尺码：{{ row.option2 }}
                </template>
              </template>
            </el-table-column>
            <el-table-column v-if="listForm.listingStatus == 4" label="失败原因">
              <template slot-scope="{row}">
                <template v-if="row.storeId">
                  <el-tooltip effect="dark" :content="row.synResult" placement="top">
                    <div class="ellipsis" style="color: red;">{{ row.synResult }}</div>
                  </el-tooltip>
                </template>
              </template>
            </el-table-column>
            <el-table-column label="Action" width="120">
              <template slot-scope="scope">
                <!-- <el-link v-if="scope.row.variants_length>1 && scope.row.variants_storeId && listForm.listingStatus != 4" type="success" class="actionColor" @click="dropdowmClick('Delete', scope.row)">{{ $t('publishListings.Delete') }}</el-link> -->
                <div v-if="scope.row.storeId === undefined"> </div>
                <!-- 更新产品时显示：Editing information in sync...
                同步listing时显示：In Sync...
                下架时显示：Being Hidden from store...
                上架时显示：On Relisting...
                新增产品时显示：On listing... -->
                <!-- 1-新增产品 2-修改产品 3-删除产品 4-下架产品 5-上架产品 6-新增变体 7-修改变体 8-删除变体 9-修改库存 -->
                <div v-else-if="scope.row.synType && scope.row.synType === 1 && scope.row.synStatus === 1">
                  <el-link type="danger">{{ $t('publishListings.synType1Title')}}</el-link>
                </div>
                <div v-else-if="scope.row.synType && scope.row.synType === 5 && scope.row.synStatus === 1">
                  <el-link type="danger">{{ $t('publishListings.synType5Title')}}</el-link>
                </div>
                <div v-else-if="scope.row.synType && scope.row.synType === 4 && scope.row.synStatus === 1">
                  <el-link type="danger">{{ $t('publishListings.synType4Title')}}</el-link>
                </div>
                <div v-else-if="scope.row.synType && scope.row.synType === 10 && scope.row.synStatus === 1">
                  <el-link type="danger">{{ $t('publishListings.synType10Title')}}</el-link>
                </div>
                <div v-else-if="scope.row.synType && scope.row.synType === 2 && scope.row.synStatus === 1">
                  <el-link type="danger">{{ $t('publishListings.synType2Title')}}</el-link>
                </div>
                <div v-else-if="scope.row.synType && scope.row.synType === 3 && scope.row.synStatus === 1">
                  <el-link type="danger">{{ $t('publishListings.synType3Title')}}</el-link>
                </div>
                <div style="width: 100px" v-else-if="scope.row.synStatus !== 1">
                  <el-link @click="EditProduct(scope.row)" type="success" style="margin-right: 10px" class="actionColor" :disabled="!scope.row.authorizeStatus">{{ listForm.listingStatus == 1 ? 'View Product' : $t('publishListings.EditProduct') }}</el-link>
                  <el-link v-if="tabTitle === 'ListingQueue'" @click="dropdowmClick('Delete', scope.row)" type="success" style="margin-right: 10px" class="actionColor" :disabled="!scope.row.authorizeStatus">{{ $t('publishListings.Delete') }}</el-link>
                </div>
                <div style="width: 100px;color: red;" v-else>
                  <el-link type="danger">{{$t('publishListings.PublishedIn')}}</el-link>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-table
            v-else
            :data="tableData"
            style="width: 100%"
            :tree-props="{children: 'variants', hasChildren: 'hasChildren'}"
            row-key="id"
            :default-expand-all="false"
            @select-all="selectAll"
            @select="selectTr"
            ref="tableData">
            <el-table-column width="50" type="selection" v-if="tabTitle !== 'Deleted'">
              <template slot-scope="scope">
                <el-checkbox v-model="scope.row.isChecked" v-if="scope.row.storeId" @change="isChecked => selectTr(isChecked, scope.row)" :disabled="checkboxIsDisabled(scope.row)"></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column :label="$t('publishListings.Product')"  prop="product" class-name="product_columns" :width="tableColumnWidth('product')">
            <template slot-scope="scope">
                <template v-if="scope.row.storeId">
                  <div class="f" style="height:95px">
                    <div style="margin: 0px 8px 0 0;padding-top: 10px">
                      <el-popover placement="right" width="280" trigger="hover">
                        <el-image fit="cover" :src="scope.row.imageUrl"></el-image>
                        <el-badge v-if="scope.row.kkProductUpdated" slot="reference" is-dot class="img-badge">
                          <el-image style="width: 64px;height: 64px;" :src="scope.row.imageUrl"></el-image>
                        </el-badge>
                        <el-image v-else slot="reference" style="width: 64px;height: 64px;" :src="scope.row.imageUrl"></el-image>
                      </el-popover>
                    </div>
                    <div class="product_title">
                      <el-tooltip effect="dark" :content="scope.row.title || scope.row.productName" placement="top">
                        <div class="ellipsis2" @click="EditProduct(scope.row)">{{ scope.row.title || scope.row.productName }}</div>
                      </el-tooltip>
                      <div>{{ $t('publishListings.ProductId') }}：{{ scope.row.productId }}</div>
                    </div>
                  </div>
                </template>
              <div v-else class="f-b" style="width: 100%">
                <div v-if="moreParams.platformCode === 'TT'">{{scope.row.sellerSku||'-'}}</div>
                <div v-else>{{scope.row.sku}}</div>
                <div v-if="scope.row.kkProductId && +scope.row.kkProductId === 1" style="color: red">
                  {{ $t('Publish.Listings.Components.TableList.NoExist') }}
                </div>
              </div>
            </template>
            </el-table-column>
            <el-table-column prop="priceScope" :label="$t('publishListings.priceScope')" :width="tableColumnWidth('priceScope')">
              <template slot-scope="scope">
                <template v-if="scope.row.priceScope">
                  <span style="font-weight: 600">{{scope.row.currency}} </span>
                  <span>{{scope.row.priceScope || '-'}}</span>
                </template>
                <template v-else>
                  <span style="font-weight: 600">{{scope.row.currency}} </span>
                  <span v-if="scope.row.price">{{scope.row.price | numberKeepTwoDecimal}}</span>
                  <span v-else>-</span>
                </template>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="compareAtPriceScope" :label="$t('publishListings.CompareAtPrice')" :width="tableColumnWidth('CompareAtPrice')">
              <template slot-scope="scope">
                <template v-if="scope.row.variantId">
                  <span style="font-weight: 600">{{scope.row.currency}} </span>
                  <span v-if="scope.row.compareAtPrice">{{scope.row.compareAtPrice | numberKeepTwoDecimal}}</span>
                  <span v-else>-</span>
                </template>
                <template v-else>
                  <span style="font-weight: 600">{{scope.row.currency}} </span>
                  <span>{{scope.row.compareAtPriceScope || ` - `}}</span>
                </template>
              </template>
            </el-table-column> -->
            <el-table-column prop="inventoryQuantityScope" :label="$t('publishListings.Inventory')" :width="tableColumnWidth('Inventory')">
              <template slot-scope="scope">
                <template v-if="scope.row.inventoryQuantityScope">{{scope.row.inventoryQuantityScope}}</template>
                <template v-else>{{scope.row.inventoryQuantity}}</template>
              </template>
            </el-table-column>
            <el-table-column :label="$t('publishListings.store')" :width="tableColumnWidth('storeName')">
              <template slot-scope="scope">
                <div >
                  {{scope.row.storeName}}
                </div>
                <div v-if="scope.row.storeId && !scope.row.authorizeStatus">
                  <el-link  style="color: red;" @click="$router.push('/personal-center/store-manage')"><span>{{ $t('Publish.Listings.Components.TableList.Authorization') }}</span> <span>{{ $t('Publish.Listings.Components.TableList.Expires') }}</span></el-link>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="Reason for failure" min-width="140" v-if="['ListingQueue', 'Suspended'].includes(tabTitle)">
              <template slot-scope="scope">
                <el-tooltip effect="dark" :content="scope.row.synResult" placement="top">
                  <div class="ellipsis" style="color: red;">{{ scope.row.synResult}}</div>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column v-if="listForm.listingStatus == 1 && tabTitle !== 'SkuNoExist'" label="Kaka Status" min-width="110">
              <template slot-scope="scope">
                <div v-if="scope.row.abnormal || scope.row.abnormal === false" style="color:#F56C6C">{{ scope.row.abnormal?$t('publishListings.soldOut'):'' }}</div>
                <div v-else :style="{color: [0, 4].includes(scope.row.skuCodeStatus)?'#F56C6C':'unset'}">{{ scope.row.skuCodeStatus === 4 ? $t('publishListings.soldOut') :  scope.row.skuCodeStatus === 0 ? $t('publishListings.notAvailable') : $t('publishListings.available') }}</div>
              </template>
            </el-table-column>
            <el-table-column label="Action" v-if="tabTitle !== 'Deleted'" width="140">
                <template slot-scope="scope">
                  <el-link v-if="scope.row.variants_length>1 && scope.row.variants_storeId && listForm.listingStatus != 4 && moreParams.platformCode !== 'TT'" type="success" class="actionColor" @click="dropdowmClick('Delete', scope.row)">{{ $t('publishListings.Delete') }}</el-link>
                  <div v-if="scope.row.storeId === undefined"> </div>
                  <!-- 更新产品时显示：Editing information in sync...
                  同步listing时显示：In Sync...
                  下架时显示：Being Hidden from store...
                  上架时显示：On Relisting...
                  新增产品时显示：On listing... -->
                  <!-- 1-新增产品 2-修改产品 3-删除产品 4-下架产品 5-上架产品 6-新增变体 7-修改变体 8-删除变体 9-修改库存 -->
                  <div v-else-if="scope.row.synType && scope.row.synType === 1 && scope.row.synStatus === 1">
                    <el-link type="danger">{{ $t('publishListings.synType1Title')}}</el-link>
                  </div>
                  <div v-else-if="scope.row.synType && scope.row.synType === 5 && scope.row.synStatus === 1">
                    <el-link type="danger">{{ moreParams.platformCode === 'TT' ? $t('publishListings.synType5TitleTT') : $t('publishListings.synType5Title')}}</el-link>
                  </div>
                  <div v-else-if="scope.row.synType && scope.row.synType === 4 && scope.row.synStatus === 1">
                    <el-link type="danger">{{ moreParams.platformCode === 'TT' ? $t('publishListings.synType4TitleTT') : $t('publishListings.synType4Title')}}</el-link>
                  </div>
                  <div v-else-if="scope.row.synType && scope.row.synType === 10 && scope.row.synStatus === 1">
                    <el-link type="danger">{{ $t('publishListings.synType10Title')}}</el-link>
                  </div>
                  <div v-else-if="scope.row.synType && scope.row.synType === 2 && scope.row.synStatus === 1">
                    <el-link type="danger">{{ $t('publishListings.synType2Title')}}</el-link>
                  </div>
                  <div v-else-if="scope.row.synType && scope.row.synType === 3 && scope.row.synStatus === 1">
                    <el-link type="danger">{{ $t('publishListings.synType3Title')}}</el-link>
                  </div>
                  <div style="width: 100px" v-else-if="scope.row.synStatus !== 1">
                    <el-link @click="EditProduct(scope.row)" type="success" style="margin-right: 10px" class="actionColor" :disabled="!scope.row.authorizeStatus">{{ $t('publishListings.EditProduct') }}</el-link>
                    <el-link @click="dropdowmClick('Delete', scope.row)" type="success" style="margin-right: 10px" v-if="tabTitle === 'ListingQueue'" class="actionColor" :disabled="!scope.row.authorizeStatus">{{ $t('publishListings.Delete') }}</el-link>
                    <el-dropdown @command="command => dropdowmClick(command, scope.row)" v-else :disabled="!scope.row.authorizeStatus">
                        <span class="el-dropdown-link">
                            <el-link type="success" class="actionColor" :disabled="!scope.row.authorizeStatus">{{ $t('publishListings.More') }}</el-link><i class="el-icon-arrow-down el-icon--right actionColor"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown" >
                            <el-dropdown-item command="Synchronous">{{ $t('publishListings.Synchronous') }}</el-dropdown-item>
                            <!-- <el-dropdown-item command="Hidden" v-if="tabTitle === 'Published' && moreParams.platformCode !== 'WC'">{{ $t('publishListings.Hidden') }}</el-dropdown-item> -->
                            <el-dropdown-item command="Hidden" v-if="tabTitle === 'Published' && moreParams.platformCode === 'TT'">{{ $t('publishListings.Deactivate') }}</el-dropdown-item>
                            <el-dropdown-item command="Relist" v-if="tabTitle === 'Hidden'">{{ moreParams.platformCode === 'TT' ? $t('publishListings.Activate') : $t('publishListings.Relist')}}</el-dropdown-item>
                            <el-dropdown-item command="Delete">{{ $t('publishListings.Delete') }}</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                  <div style="width: 100px;color: red;" v-else>
                    <el-link type="danger">{{$t('publishListings.PublishedIn')}}</el-link>
                  </div>
                </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="f-e">
          <el-pagination
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[20, 50, 100, 200]"
                :total="total"
                class="myPagination"
                :current-page.sync="listForm.pageNumber"
                :page-size="listForm.pageSize"
                @current-change="pageCurrentChange"
                @size-change="pageSizeChange"/>
        </div>
        <el-dialog
          :visible.sync="dialogVisible"
          width="400px"
          :before-close="handleClose"
          :modal="false">
          <p style="font-size: 16px;">
            <i class="el-icon-warning-outline" style="font-size: 18px;color: #930000"></i>
            {{ $t('Publish.Listings.Components.TableList.Tips1') }} {{ platformMap[platformCode] }}
          </p>
          <div class="f-c" style="margin: 60px 0 10px;">
            <el-button type="primary" style="width: 240px" @click="toEdit(checkingProduct)">{{ $t('Publish.Listings.Components.TableList.ReList') }}</el-button>
          </div>
          <div class="f-c">
            <el-button style="width: 240px" @click="toDeleted">{{ $t('Publish.Listings.Components.TableList.Tips2') }}</el-button>
          </div>
        </el-dialog>
        <BatchUpdate ref="batchUpdate" :platformCode="platformCode" @updateSuccess="getList"></BatchUpdate>
    </div>
</template>

<script>
import API from '@/api'
import _ from 'lodash'
import BatchUpdate from './BatchUpdate.vue'
export default {
  components: { BatchUpdate },
  props: {
    tabTitle: {
      type: String,
      default: () => 'Published'
    },
    platformCode: {
      type: String,
      default: () => ''
    },
    moreParams: {
      type: Object,
      default: () => ({
        searchContent: undefined,
        platformCode: 'SP',
        storeIds: [],
        taskNos: []
      })
    },
    searchString: {
      type: String,
      default: () => ''
    },
    batchSearchValue: {
      type: String,
      default: () => ''
    },
    singleSearchValue: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      tableData: [],
      searchContent: undefined,
      listForm: {
        pageNumber: 1,
        pageSize: 20,
        listingStatus: 1,
        productStatus: '2' // 2 PENDING(待定)，3 FAILED(停售)，7 FREEZE (冻结)
      },
      ttTabs: [
        { label: 'publishListings.Reviewing', name: '2', arr: 'PENDING' },
        { label: 'publishListings.Frozen', name: '7', arr: 'FREEZE' },
        { label: 'publishListings.Failed', name: '3', arr: 'FAILED' }
      ],
      searchParams: {
        searchContent: undefined,
        storeIds: undefined
      },
      total: 1,
      selectionListCurrent: [], // 选中的 存的是 id
      selectionListAll: [], // 选中的 存的是 row
      isAllSelect: false,
      searchContentStatus: false, // 是否输入框有值状态，优化交互使用
      srcList: [],
      dialogVisible: false, // 编辑时产品已删除弹窗
      checkingProduct: null, // 已删除弹窗展示时操作得产品

      sizeTemplate: undefined, // 尺码表
      paramColumn: [] // 尺码表动态表头
    }
  },
  created() {
    this.listForm.listingStatus = {
      Published: '1',
      Hidden: '2',
      Deleted: '3',
      ListingQueue: '4',
      SkuNoExist: '1',
      Suspended: '6',
      WaitingForUpdate: '7'
    }[this.tabTitle]
    if (this.tabTitle !== 'Suspended' && this.listForm.productStatus) {
      delete this.listForm.productStatus
    }
  },
  computed: {
    hiddenComfirmTitle() {
      return this.$t('publishListings.hiddenComfirmTitle')
    },
    RelistComfirmTitle() {
      return this.$t('publishListings.RelistComfirmTitle')
    },
    deleteComfirmTitle() {
      return this.$t('publishListings.deleteComfirmTitle')
    },
    platformOptions() {
      if (!this.$store.state.common.platformOptions.length) this.$store.dispatch('common/getPlatformOptions')
      return this.$store.state.common.platformOptions
    },
    platformMap() {
      return {
        SP: 'Shopify',
        DJ: 'Shoplazza',
        SL: 'Shopline',
        WC: 'Woocommerce'
      }
    }
  },
  methods: {
    async EditProduct(row) {
      if (await this.getPublications(row.storeId)) return
      try {
        if (+this.listForm.listingStatus === 3) {
          this.jumpDetailSeo(row.kkProductId)
          return
        }
        if (!row.authorizeStatus || row.synStatus === 1) return
        const { storeId, productId } = row
        if (this.tabTitle !== 'ListingQueue' && this.moreParams.platformCode !== 'PD') {
          const loading = this.$loading.service()
          const { data, code, message } = await API.publishGetListingsRealTimeStatus({ storeId, productId, platformCode: this.platformCode })
          loading.close()
          if (code !== 10000) return this.$message.error(message)
          if (!data) {
            this.checkingProduct = row
            this.dialogVisible = true
            return
          }
        }
        let query = {
          id: row.id,
          listingStatus: this.listForm.listingStatus,
          storeId: row.storeId,
          platformCode: this.moreParams.platformCode,
          isEdit: 1
        }
        if (row.updateProcessed === 1) {
          query.productId = row.productId
          query.updateProcessed = 1
          query.storeId = row.storeId
        }
        if (this.platformCode === 'PD') {
          this.$router.push({
            path: '/publish/listings/temuCreate',
            query
          })
        } else {
          this.$router.push({
            path: '/publish/edit',
            query
          })
        }
      } catch (error) {
        this.$message.error(error.data.message)
        // this.toDeleted()
      }
    },
    // 重新刊登   新增
    toEdit(row) {
      this.$router.push({
        path: '/publish/edit',
        query: {
          kkProductId: row.kkProductId,
          storeId: row.storeId,
          storeName: row.storeName,
          platformCode: this.platformCode,
          platformName: this.platformMap[this.platformCode]
        }
      })
    },
    async getList(type) {
      let res
      if (type === 'update') {
        // 更新后清除选中
        this.selectionListCurrentRemove(this.selectionListCurrent)
      }
      if (this.moreParams.platformCode === 'PD' && this.tabTitle === 'ListingQueue') {
        this.listForm.listingStatus = '4'
      }
      const params = Object.assign({}, this.listForm, this.moreParams, { taskNos: this.moreParams.taskNos })
      params[this.searchString] = ['productIds', 'skus', 'spuCodes'].includes(this.searchString) ? this.batchSearchValue.split('\n').filter(e => e) : this.singleSearchValue
      // sku不存在列表与原数据来源不同，故分开
      if (this.tabTitle === 'SkuNoExist') {
        this.SkuNoExistGetList(params, 'userGroup')
        return
      }
      // // Waiting For Update 待更新不同请求接口
      // if (this.tabTitle === 'WaitingForUpdate') {
      //   this.SkuNoExistGetList(params, 'updated')
      //   return
      // }
      const loading = this.$loading.service()
      try {
        if (this.moreParams.platformCode === 'DJ') {
          res = await API.shoplazzaGetListings(params)
        } else if (this.moreParams.platformCode === 'SP') {
          res = await API.publishGetListings(params)
        } else if (this.moreParams.platformCode === 'SL') {
          res = await API.shoplineGetListings(params)
        } else if (this.moreParams.platformCode === 'WC') {
          res = await API.WoocommerceGetListings(params)
        } else if (this.moreParams.platformCode === 'TT') {
          res = await API.tiktokGetListings(params)
        } else if (this.moreParams.platformCode === 'PD') {
          res = await API.temuGetListings(params)
        }
        if (res.code !== 10000) {
          loading.close()
          let message = res.message || res.data.message
          this.$message.error(message)
          return
        }
        let key = this.listForm.listingStatus
        if (this.moreParams.platformCode === 'TT' && +this.listForm.listingStatus === 6) {
          key = this.ttTabs[this.ttTabs.findIndex(t => t.name === this.listForm.productStatus) || 0].arr
        }
        let type = Object.prototype.toString.call(res.data[key]).slice(8, -1)
        if (type === 'Array') {
          this.tableData = res.data[key]
          this.total = res.data.count[this.listForm.listingStatus]
          // 把总数传出外层展示
          // 'Published': '1',
          // 'Hidden': '2',
          // 'Deleted': '3',
          // 'ListingQueue': '4'
          ;[1, 2, 3, 4, 6, 7].forEach(listingStatus => {
            const point = {
              1: 'Published',
              2: 'Hidden',
              3: 'Deleted',
              4: 'ListingQueue',
              6: 'Suspended',
              7: 'WaitingForUpdate'
            }
            this.$emit('getTotal', { total: res.data.count[listingStatus], tabTitle: point[listingStatus] })
          })
          if (this.moreParams.platformCode === 'TT') {
            this.ttTabs.forEach(item => {
              let key = item.arr + '_count'
              this.$set(item, 'count', res.data.count[key] || 0)
            })
          }
          this.dataHandle(this.tableData)
          this.searchContentStatus = !!this.searchParams.searchContent
          loading.close()
          return this.isEmptyAllData(params, res.data.count)
        }
      } catch (error) {
        loading.close()
        let message = error.message || error.data.message
        this.$message.error(message)
        return true
      }
    },
    dataHandle(tableData) {
      tableData.forEach((e, i) => {
        let isChecked = this.selectionListCurrent.includes(e.id)
        this.$set(e, 'isChecked', isChecked)
        this.$nextTick(() => {
          isChecked && this.$refs.tableData.toggleRowSelection(e, isChecked)
        })
        !e.variants && this.$set(e, 'variants', [])
        e.variants.forEach(ee => {
          // 附上唯一id
          ee.id = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random() * 16 | 0; var v = c === 'x' ? r : (r & 0x3 | 0x8)
            return v.toString(16)
          })
          this.$set(ee, 'currency', e.currency)
          this.$set(ee, 'variants_storeId', e.storeId)
          this.$set(ee, 'variants_length', e.variants.length)
        })
      })
      this.srcList = tableData.map(e => e.imageUrl)
    },
    pageCurrentChange(page) {
      this.listForm.pageNumber = page
      // 当前页选中存入所有选中记录数组
      this.getList({})
    },
    // 表格上方批量操作按钮  下架上架删除
    buttonHandleClickAll(handle) {
      const that = this
      switch (handle) {
        case 'Hidden':
          that.$confirm('Are you sure to Off Shelf these products from store?')
            .then(_ => {
              this.batchRelistHidden(this.selectionListCurrent, 2)
            })
            .catch(_ => {})
          break
        case 'Delete':
          that.$confirm(this.deleteComfirmTitle)
            .then(_ => {
              this.publishListingDelete(this.selectionListCurrent, this.listForm.listingStatus)
            })
            .catch(_ => {})
          break
        case 'Relist':
          that.$confirm('Are you sure to relist these products to the store?')
            .then(_ => {
              this.batchRelistHidden(this.selectionListCurrent, 1)
            })
            .catch(_ => {})
          break
        case 'Update':
          this.batchUpdate(this.selectionListCurrent)
          break
        default:
          break
      }
    },
    // 表格操作按钮
    async dropdowmClick(command, row) {
      const that = this
      switch (command) {
        case 'Synchronous':
          if (this.moreParams.platformCode === 'DJ') {
            API.shoplazzaSyncListings({ storeIds: [row.storeId], productIds: [row.productId] }).then(res => {
              this.$message.success(res.message)
              this.selectionListCurrentRemove([row.id])
              this.$emit('refresh', this.tabTitle)
            })
          } else if (this.moreParams.platformCode === 'SP') {
            API.publishSyncListings({ storeIds: [row.storeId], productIds: [row.productId] }).then(res => {
              this.$message.success(res.message)
              this.selectionListCurrentRemove([row.id])
              this.$emit('refresh', this.tabTitle)
            })
          } else if (this.moreParams.platformCode === 'SL') {
            API.shoplineSyncListings({ storeIds: [row.storeId], productIds: [row.productId] }).then(res => {
              this.$message.success(res.message)
              this.selectionListCurrentRemove([row.id])
              this.$emit('refresh', this.tabTitle)
            })
          } else if (this.moreParams.platformCode === 'WC') {
            API.WoocommerceSyncListings({ storeIds: [row.storeId], productIds: [row.productId] }).then(res => {
              this.$message.success(res.message)
              this.selectionListCurrentRemove([row.id])
              this.$emit('refresh', this.tabTitle)
            })
          } else if (this.moreParams.platformCode === 'TT') {
            API.tiktokSyncListings({ storeIds: [row.storeId], productIds: [row.productId] }).then(res => {
              this.$message.success(res.message)
              this.selectionListCurrentRemove([row.id])
              this.$emit('refresh', this.tabTitle)
            })
          }
          break
        case 'Hidden':
          that.$confirm(this.hiddenComfirmTitle)
            .then(_ => {
              this.batchRelistHidden([row.id], 2)
            })
            .catch(_ => {})
          break
        case 'Relist':
          that.$confirm(this.RelistComfirmTitle)
            .then(_ => {
              this.batchRelistHidden([row.id], 1)
            })
            .catch(_ => {})
          break
        case 'Delete':
          that.$confirm(this.deleteComfirmTitle)
            .then(_ => {
              // 判断删除Listing还是变体
              if (row.variants_storeId) this.publishListingVariantDelete(row.variants_storeId, row.productId, row.variantId)
              else this.publishListingDelete([row.id], this.listForm.listingStatus)
              // this.publishListingDelete([row.id], this.listForm.listingStatus)
            })
            .catch(_ => {})
          break
        default:
          break
      }
    },
    // 操作完去除当前的已选
    selectionListCurrentRemove(ids) {
      // 直接用ids会出现  undefinen???
      const newIds = JSON.parse(JSON.stringify(ids))
      newIds.forEach(id => {
        let index = this.selectionListCurrent.indexOf(id)
        if (index !== -1) {
          this.selectionListCurrent.splice(index, 1)
        }
      })
    },
    // 批量上架&上架&批量下架&下架   type   1上架2下架
    async batchRelistHidden(ids, type) {
      const params = { data: { ids, type }}
      let res
      try {
        if (this.moreParams.platformCode === 'DJ') {
          res = await API.shoplazzaListingStatus(params)
        } else if (this.moreParams.platformCode === 'SP') {
          res = await API.publishListingStatus(params)
        } else if (this.moreParams.platformCode === 'SL') {
          res = await API.shoplineListingStatus(params)
        } else if (this.moreParams.platformCode === 'WC') {
          res = await API.WoocommerceListingStatus(params)
        } else if (this.moreParams.platformCode === 'TT') {
          res = await API.tiktokListingStatus(params)
        }
        this.$message.success(res.message)
        this.selectionListCurrentRemove(ids)
        this.$emit('refresh', this.tabTitle)
      } catch (err) {
        let message = err.message || err.data.message
        this.$message.error(message)
      }
    },
    // 删除  批量删除
    async publishListingDelete(ids, listingStatus) {
      const params = { data: { ids, listingStatus }}
      let res
      try {
        if (this.moreParams.platformCode === 'DJ') {
          res = await API.shoplazzaListingDelete(params)
        } else if (this.moreParams.platformCode === 'SP') {
          res = await API.publishListingDelete(params)
        } else if (this.moreParams.platformCode === 'SL') {
          res = await API.shoplineListingDelete(params)
        } else if (this.moreParams.platformCode === 'WC') {
          res = await API.WoocommerceListingDelete(params)
        } else if (this.moreParams.platformCode === 'TT') {
          res = await API.tiktokListingDelete(params)
        } else if (this.moreParams.platformCode === 'PD') {
          res = await API.temuListingDelete(params)
        }
        if (res.code !== 10000) return this.$message.error(res.message)
        this.$message.success(res.message)
        this.selectionListCurrentRemove(ids)
        this.$emit('refresh', this.tabTitle)
      } catch (err) {
        let message = err.message || err.data.message
        this.$message.error(message)
      }
    },

    // 删除sku
    publishListingVariantDelete(storeId, productId, variantId) {
      API.publishListingVariantDelete({
        storeId, productId, variantId, platformCode: this.moreParams.platformCode
      }).then(res => {
        if (res.code !== 10000) return this.$message.error(res.message)
        this.$message.success(res.message)
        this.$emit('refresh', this.tabTitle)
      })
    },

    // 批量更新产品
    async batchUpdate() {
      if (_.uniqBy(this.selectionListAll, 'storeId').length > 1) {
        this.$message.error('For batch update, only products of one account can be selected.')
        return
      }
      if (await this.getPublications(this.selectionListAll[0].storeId)) return
      this.$refs.batchUpdate.show(this.selectionListCurrent)
    },

    // 全选/取消选操作
    selectAll() {
      this.isAllSelect = !this.isAllSelect
      this.tableData.forEach(row => {
        this.selectTr(this.isAllSelect, row)
      })
    },
    // 选择某行
    selectTr(isChecked, row) {
      if (row.synType) {
        if (row.synType && row.synStatus === 1) {
          this.$set(row, 'isChecked', false)
        } else {
          this.$set(row, 'isChecked', isChecked)
        }
      } else {
        this.$set(row, 'isChecked', isChecked)
      }
      this.$refs.tableData.toggleRowSelection(row, isChecked)
      this.$nextTick(() => {
        // 与记录数组同步
        if (row.isChecked) {
          if (!this.selectionListCurrent.includes(row.id)) {
            this.selectionListCurrent.push(row.id)
            this.selectionListAll.push(row)
          }
        } else {
          let index = this.selectionListCurrent.indexOf(row.id)
          if (index !== -1) {
            this.selectionListCurrent.splice(index, 1)
            this.selectionListAll.splice(index, 1)
          }
        }
      })
    },
    // 表格宽度
    tableColumnWidth(column) {
      const obj = {
        Published: {
          product: 284,
          priceScope: 185,
          CompareAtPrice: 185,
          Inventory: 120,
          storeName: 200
        },
        Hidden: {
          product: 384, // product: 284,
          priceScope: 215, // priceScope: 185,
          CompareAtPrice: 185,
          Inventory: 190, // Inventory: 120,
          storeName: 220 // storeName: 210
        },
        WaitingForUpdate: {
          product: 384, // product: 284,
          priceScope: 215, // priceScope: 185,
          CompareAtPrice: 185,
          Inventory: 190, // Inventory: 120,
          storeName: 220 // storeName: 210
        },
        ListingQueue: {
          product: 284,
          priceScope: 155,
          CompareAtPrice: 155,
          Inventory: 100,
          storeName: 150
        },
        Deleted: {
          product: 520, // product: 420,
          priceScope: 265, // priceScope: 235,
          CompareAtPrice: 235,
          Inventory: 210, // Inventory: 120,
          storeName: 200 // storeName: 190
        },
        SkuNoExist: {
          product: 374, // product: 184,
          priceScope: 235, // priceScope: 185,
          CompareAtPrice: 185,
          Inventory: 180, // Inventory: 120,
          storeName: 220 // storeName: 210
        },
        Suspended: {
          product: 284,
          priceScope: 155,
          CompareAtPrice: 155,
          Inventory: 100,
          storeName: 150
        }
      }
      return obj[this.tabTitle][column]
    },
    checkboxIsDisabled(row) {
      let isDisabled = false
      if (row.synType) {
        isDisabled = [
          (row.synType === 1 && row.synStatus === 1),
          (row.synType === 5 && row.synStatus === 1),
          (row.synType === 4 && row.synStatus === 1),
          (row.synType === 10 && row.synStatus === 1),
          (row.synType === 2 && row.synStatus === 1),
          (row.synStatus === 1)
        ].some(e => e)
      }
      return isDisabled
    },
    pageSizeChange(pageSize) {
      this.listForm.pageSize = pageSize
      this.getList()
    },
    isEmptyAllData(params, count) {
      let isEmptyAllData = Object.keys(count).every(k => count[k] === 0)
      if (params.searchContent) isEmptyAllData = false
      if (params.storeIds && params.storeIds.length) isEmptyAllData = false
      if (params.taskNos && params.taskNos.length) isEmptyAllData = false
      if (params.productIds && params.productIds.length) isEmptyAllData = false
      if (params.spuCodes && params.spuCodes.length) isEmptyAllData = false
      return isEmptyAllData
    },
    SkuNoExistGetList(params, type) {
      return new Promise((resolve, reject) => {
        params.listingStatus = 1
        if (type === 'updated') params.kkProductUpdated = true
        else params.kkProductId = 1
        const loading = this.$loading.service()
        API.publishGetSkuNotExitListings(params).then(res => {
          this.tableData = res.data.list
          this.total = res.data.total
          this.$emit('getTotal', { total: this.total, tabTitle: this.tabTitle })
          this.dataHandle(this.tableData)
          this.searchContentStatus = !!this.searchParams.searchContent
          resolve(this.isEmptyAllData(params, this.total))
        }).finally(() => {
          loading.close()
          reject()
        })
      })
    },
    SkuNoExistGetTotal(moreParams, type) {
      const params = Object.assign({}, this.listForm, this.moreParams, { taskNos: this.moreParams.taskNos })
      params[this.searchString] = ['productIds', 'skus', 'spuCodes'].includes(this.searchString) ? this.batchSearchValue.split('\n').filter(e => e) : this.singleSearchValue
      params.listingStatus = 1
      if (type === 'updated') params.kkProductUpdated = true
      else params.kkProductId = 1
      API.publishGetSkuNotExitListings(params).then(res => {
        this.$emit('getTotal', { total: res.data.total, tabTitle: this.tabTitle })
      }).finally(() => {
      })
    },

    // Waiting For Update
    // waitingUpdateList(params) {
    //   return new Promise((resolve, reject) => {
    //     const loading = this.$loading.service()
    //     API.publishGetSkuNotExitListings(params).then(res => {
    //       this.tableData = res.data.list
    //       this.total = res.data.total
    //       this.$emit('getTotal', { total: this.total, tabTitle: this.tabTitle })
    //       this.dataHandle(this.tableData)
    //       this.searchContentStatus = !!this.searchParams.searchContent
    //       resolve(this.isEmptyAllData(params, this.total))
    //     }).finally(() => {
    //       loading.close()
    //       reject()
    //     })
    //   })
    // },

    handleClose() {
      this.checkingProduct = null
      this.dialogVisible = false
    },
    toDeleted() {
      this.handleClose()
      this.$emit('toDeleted')
    },
    // 清除选中
    resetSelection() {
      this.selectionListCurrent = []
      this.selectionListAll = []
      this.isAllSelect = false
    },

    // temu创建商品
    createProduct() {
      this.$router.push('/publish/listings/temuCreate')
    },

    // 查看尺码表
    temuGetNotReusableSizeCharts(businessIds) {
      API.temuGetNotReusableSizeCharts({ businessIds }).then(res => {
        let selChart = res.data[0]
        this.sizeTemplate = selChart
        let paramColumn = []
        selChart.content.meta.elementList.forEach(t => {
          paramColumn.push({
            key: t.id,
            title: t.name,
            input: ''
          })
        })
        this.paramColumn = paramColumn
        this.$set(this.sizeTemplate, 'sizeList', selChart.content.records.map(t => ({ ...t.values })))
      })
    },

    async getPublications(storeId) {
      let dialogStoreUpdate = false
      try {
        if (this.moreParams.platformCode !== 'SP') return
        let res = await API.getPublications({ storeId })
        if (res.code === 10000 && res.data) {
          this.$emit('shopifyUpgrade', res.data)
          dialogStoreUpdate = true
        }
      } catch (error) {
        if (error.data.data.includes('errors')) {
          this.$message.error(JSON.parse(error.data.data).errors)
          dialogStoreUpdate = true
        }
        console.error('Error:', error)
      }
      return dialogStoreUpdate
    }
  }
}
</script>

<style lang="scss" scoped>
.listing-main {
  // position: relative;
  // .mask {
  //   position: absolute;
  //   background: rgba($color: #888, $alpha: 0.4);
  //   width: 100%;
  //   height: 100%;
  //   z-index: 100;
  //   .hint {
  //     position: fixed;
  //     left: calc(50% - 50px);
  //     top: 40%;
  //     width: 340px;
  //     height: 160px;
  //     background-color: #fff;
  //     border-radius: 10px;
  //     .text {
  //       padding-top: 50px;
  //     }
  //     .btn {
  //       width: 100%;
  //       height: 50px;
  //       position: absolute;
  //       bottom: 0;
  //       border-top: 1px solid #eee;
  //       color: #99C41C;
  //       cursor: pointer;
  //     }
  //   }
  // }
}
.img-badge {
  /deep/ .el-badge__content.is-dot{
    width: 16px;
    height: 16px;
    top: 2px !important;
    right: 10px !important;
  }
  position: relative;
}
.inputGroup {
    width: 450px;
    /deep/.el-input__inner {
        border-top-left-radius: 30px;
        border-bottom-left-radius: 30px;
    }
    /deep/.el-input-group__append {
        border-top-right-radius: 30px;
        border-bottom-right-radius: 30px;
        background-color: rgba(153, 196, 28, 0.2);
    }
}
.myPagination {
  padding: 8px 5px;
  /deep/.number {
      border: 1px solid #D9D9D9;
      margin: 0 5px;
      padding: 0;
      min-width: 30px;
  }
}
.product_title {
  padding-top: 10px;
  height: 100%;
  >div:nth-of-type(1) {
    font-size: 14px;
    text-decoration:underline;
    cursor: pointer;
  }
  >div:nth-of-type(2) {
    font-size: 12px;
    color: #747A87;
  }
}
.actionColor {
  color: #99C41C;
}
</style>

<style lang="scss">
.product_columns {
  display: flex;
  .cell {
      display: flex;
      align-items: center;
    }
}
</style>
